import {
  type QueryKey,
  type UseQueryOptions,
  useQuery,
} from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { identifyAnalyticsUser } from '@flecto/analytics/src/provider'
import { getUserLogged } from '@flecto/api/shared'
import { type CoreUser } from '@flecto/types'

// Usage for invalidation
export const getUserQueryKey: QueryKey = ['QueryGetUserLogged']

export function useQueryGetUserLogged(options?: UseQueryOptions<CoreUser>) {
  const router = useRouter()

  /**
   * @todo Remove this logic from here and move it to the place on flecto link
   *       that is using this hook.
   */
  const isFlectoLink = router.asPath.startsWith('/b_') ?? false

  const isEnabled =
    typeof options?.enabled === 'boolean' ? options.enabled : !isFlectoLink

  return useQuery<CoreUser>({
    queryKey: getUserQueryKey,
    queryFn: async () => await getUserLogged(),
    refetchOnWindowFocus: false,
    ...(options || {}),
    onSuccess(data) {
      identifyAnalyticsUser(data.id)
      options?.onSuccess?.(data)
    },
    // Dont remove retry
    retry: 6,
    retryDelay: 400,
    enabled: isEnabled,
  })
}
